import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './styles';

function ShortcutsSelect(props) {
  const { shortcutItems, selectedId, handleSelect } = props;
  const { classes } = useStyles();

  return (
    <Select
      className={classes.defaultSelect}
      value={selectedId}
      onChange={(e) => handleSelect(e?.target?.value)}
      IconComponent={ExpandMoreIcon}
    >
      {shortcutItems.map((item) => (
        <MenuItem className={classes.menuItem} key={item.id} value={item.id}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

ShortcutsSelect.propTypes = {
  shortcutItems: PropTypes.array.isRequired,
  selectedId: PropTypes.string.isRequired,
  handleSelect: PropTypes.func.isRequired,
};

export default ShortcutsSelect;
